<template>
  <div id="app">
    <div id=navbar>
      <div class="gerakan-pandai">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#0099ff" fill-opacity="1" d="M0,96L60,90.7C120,85,240,75,360,64C480,53,600,43,720,48C840,53,960,75,1080,96C1200,117,1320,139,1380,149.3L1440,160L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path></svg> -->
        <b-navbar>
          <template #start>
          <img class="logo-pandai"
            src="../assets/logogerpan.png"
            style="margin-top: 5px; margin-left: 2px; width: 300px; height: 90px; object-position: center; object-fit: contain;"
          />
          </template>
          <template #end>
          <img class="logo-bebras"
            src="../assets/bebrasIndo.png"
            style="margin-top: 5px; margin-right: 2px; width: 200px; height: 90px; object-position: center; object-fit: contain;"
          />
          </template>
        </b-navbar>
      </div>
      <div class="nav-top" style="color: white;">
        <b-navbar style="background-color: #2196F3;">
          <template #brand>
            <b-navbar-item style="serif">
            </b-navbar-item>
          </template>
          <template #start>
              <b-navbar-item 
                icon-left="book-open-variant"
                @click="homepage()">
                  Beranda
              </b-navbar-item>
              <b-navbar-item 
                icon-left="book-open-variant"
                @click="tentang()">
                  Tentang
              </b-navbar-item>
              <b-navbar-dropdown label="Sorting">
                  <b-navbar-item 
                    @click="sortEvent()">
                      Event
                  </b-navbar-item>
                  <b-navbar-item
                    @click="sortBlog()">
                      Blog
                  </b-navbar-item>
              </b-navbar-dropdown>
              <b-navbar-dropdown label="Statistik">
                  <b-navbar-item
                    @click="grafikPerBiro()">
                      Grafik Biro
                  </b-navbar-item>
                  <b-navbar-item
                    @click="grafikAll()">
                      Grafik All
                  </b-navbar-item>
              </b-navbar-dropdown>
          </template>

          <template #end>
              <b-navbar-item tag="div">
                <b-button
                    class="button"
                    type="is-light"
                    id="login"
                    @click="isComponentModalActive = true"
                    icon-left="account">
                    Masuk
                </b-button>
                <b-modal
                    v-model="isComponentModalActive"
                    has-modal-card
                    trap-focus
                    :destroy-on-hide="false"
                    aria-role="dialog"
                    aria-modal
                  >
                    <template #default="props">
                      <modal-form
                        :email="formProps.email"
                        :password="formProps.password"
                        @close="props.close"
                        @netralizeEmail="netralize(formProps.email)"
                        @netralizePassword="netralize(formProps.password)"
                        @login="login()"
                        @reset="resetForm()"
                      >
                      </modal-form>
                    </template>
                  </b-modal>
              </b-navbar-item>
          </template>
        </b-navbar>
      </div>
    </div>

    <router-view/>

    <div id="content-homepage" v-show="state">
      <div>
        <div>
          <b-carousel
            v-if="carousel"
            :pauseHover="false"
            :pauseInfo="false"
            :interval="10000"
            :indicator="true"
            :indicator-inside="true"
            indicator-mode="hover"
            indicator-position="is-bottom"
            indicator-style="is-lines"
          >
              <b-carousel-item>
                <section class="hero is-large">
                  <div class="hero-head has-text-centered">
                    <figure class="image is-3by3">
                      <img src="../assets/banner2023.jpeg"
                        alt="carousel-1"
                        style="object-position: center; object-fit: cover;height:600px; filter: brightness(0.5)"/>
                    </figure>
                  </div>
                </section>
              </b-carousel-item>
              <b-carousel-item>
                <section class="hero is-large">
                  <div class="hero-head has-text-centered">
                    <figure class="image is-3by3">
                      <img src="../assets/bebrasBanner.jpg"
                        alt="carousel-1"
                        style="object-position: center; object-fit: cover;height:600px; filter: brightness(0.5)"/>
                    </figure>
                  </div>
                </section>
              </b-carousel-item>
              <b-carousel-item>
                <section class="hero is-large">
                  <div class="hero-head has-text-centered">
                    <figure class="image is-3by3">
                      <img
                        src="../assets/grow-with-google-bebras-id.jpg"
                        alt="carousel-1"
                        style="object-position: center; object-fit: cover; height:600px;filter: brightness(0.5)"
                      />
                    </figure>
                  </div>
                </section>
              </b-carousel-item>
              <b-carousel-item>
                <section class="hero">
                  <div class="hero-head has-text-centered">
                  
                    <figure class="image is-3by3">
                      <img
                        src="../assets/carousel5.png"
                        alt="carousel-1"
                        style="object-position: center; object-fit: cover; height:600px;filter: brightness(0.5)"
                      />
                    </figure>
                  </div>
                </section>
              </b-carousel-item>
          </b-carousel>
        </div>
        <div>
      </div>
        <section>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#0099ff" fill-opacity="0.5" d="M0,224L40,234.7C80,245,160,267,240,250.7C320,235,400,181,480,181.3C560,181,640,235,720,224C800,213,880,139,960,138.7C1040,139,1120,213,1200,218.7C1280,224,1360,160,1400,128L1440,96L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"></path></svg>
          <div class="rows" style="margin-top: -250px">
            <div class="row">
              <p class="title has-text-centered" style="font-size:30px">Statistik Gerakan Pandai</p>
              <div class="columns" style="margin:20px">
                <div class="column"></div>
                <div class="column">
                  <span class="image is-128x128 " >
                      <img style="object-position: center; object-fit: contain" src="../assets/total_guru.png">   
                  </span>
                </div>
                <div class="column">
                   <p style="has-text-centered;font-weight:bold;font-size:18px">Total GURU</p>
                    
                     <p style="has-text-centered;font-weight:bold;font-size:30px">TERSERTIFIKASI</p>
                     <!-- <br> -->
                    <p style="has-text-centered;font-weight:bold;font-size:30px"> {{all.total_guru}}</p>  
                </div>
                <div class="column">
                  <span class="image is-128x128" >   
                      <img style="object-position: center; object-fit: contain" src="../assets/kota.png">                  
                  </span>
                </div>
                 <div class="column">
                  <p style="has-text-centered;font-weight:bold;font-size:18px">Total</p>
                    
                     <p style="has-text-centered;font-weight:bold;font-size:30px">KOTA</p>
                     <!-- <br> -->
                    <p style="has-text-centered;font-weight:bold;font-size:30px"> {{all.total_kota}}</p>    
                </div>
                <!-- <div class="column">
                  <p style="has-text-centered;font-weight:bold;font-size:18px">Total <span style="has-text-centered;font-weight:bold;font-size:30px">ROMBEL</span></p>
                  <p style="has-text-centered;font-size:14px">Microteaching</p>
                  <p style="has-text-centered;font-weight:bold;font-size:30px"> {{grafik.total_event_siswa}}</p>  
                </div> -->
                <div class="column">
                  <span class="image is-128x128" >
                      <img style="object-position: center; object-fit: contain" src="../assets/total_siswa.png">                  
                  </span>
                </div>
                <div class="column">
                  <p style="has-text-centered;font-weight:bold;font-size:18px">Total</p>
                  <p style="has-text-centered;font-weight:bold;font-size:30px">SISWA</p>
                  <!-- <p style="has-text-centered;font-size:14px">Microteaching</p> -->
                  <!-- <br> -->
                  <p style="has-text-centered;font-weight:bold;font-size:30px"> {{grafik.total_siswa}}</p>  
                </div>
                <div class="column"></div>
              </div>
            </div>
            <div class="row">
              <div class="columns" style="margin:20px">
                <div class="column"></div>
                <div class="column"></div>
                <div class="column">
                  <span class="image is-128x128" >
                      <img style="object-position: center; object-fit: contain" src="../assets/guru_teaching1.png">                
                  </span>
                </div>
                 <div class="column">
                  <span class="image is-128x128" style="margin-left:1%">
                      <img style="object-position: center; object-fit: contain" src="../assets/guru_teaching2.png">                
                  </span>
                </div>
                <div class="column">
                  <p style="has-text-centered;font-weight:bold;font-size:18px">Total</p>
                   <p style="has-text-centered;font-weight:bold;font-size:30px">GURU</p>
                   <!-- <p style="has-text-centered;font-weight:bold;font-size:18px">Total <span style="has-text-centered;font-weight:bold;font-size:30px">GURU</span></p> -->
                   <!-- <p style="has-text-centered;font-size:14px">Workshop Guru</p> -->
                   <p style="has-text-centered;font-weight:bold;font-size:30px"> {{grafik.total_guru}}</p>  
                </div>
                <div class="column">
                  <span class="image is-128x128" >
                      <img style="object-position: center; object-fit: contain" src="../assets/total_event.png">                  
                  </span>
                </div>
                 <div class="column">
                   <p style="has-text-centered;font-weight:bold;font-size:18px">Total <span style="has-text-centered;font-weight:bold;font-size:30px">WORKSHOP</span></p>
                   <!-- <p style="has-text-centered;font-size:14px">Workshop Guru</p> -->
                   <p style="has-text-centered;font-weight:bold;font-size:30px"> {{grafik.total_event_guru}}</p>  
                </div>
                <div class="column"></div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section>
        <br>
          <b-tabs position="is-centered"  id="blognews" style="background-color:#F2F1F7">
            <b-tab-item label="News" icon="bullhorn">
              <div class="columns">
                <div class="column has-text-centered">  
                <h1 style="font-size:30px;font-weight:bold">GERAKAN PANDAI <span style="font-size:30px;font-weight:bold;color:blue">NEWS</span></h1>
                </div>
              </div>
              <div class="rows">
                <div class="row">
                  <div class="columns">
                    <div class="column is-9">
                      <article>
                        <div id="datablog">
                          <div id="content">
                            <div>
                              <div class="columns is-multiline">
                                <div class="column is-half" v-for="news in paginatedItemsNews" :key="news.id_news" :data="news">
                                  <div class="card image animate__animated animate__backInUp">
                                    <div class="card-content">
                                      <h1 class="image animate__animated animate__backInUp has-text-centered" style="color:blue; font-size:20px"><b>{{news.title}}</b></h1>
                                    </div>
                                    <div class="card-image ">
                                      <b-carousel :autoplay="false" :interval="8000">
                                        <b-carousel-item v-if="news.picture !== null">
                                          <figure class="image is-3by3">
                                            <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture)" alt="Product photos">
                                          </figure>
                                        </b-carousel-item>

                                        <b-carousel-item v-if="news.picture1 !== null">
                                          <figure class="image is-3by3">
                                            <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture1)" alt="Product photos">
                                          </figure>
                                        </b-carousel-item>

                                        <b-carousel-item v-if="news.picture2 !== null">
                                          <figure class="image is-3by3">
                                            <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture2)" alt="Product photos">
                                          </figure>
                                        </b-carousel-item>

                                        <b-carousel-item v-if="news.url !== null">
                                          <figure class="image is-3by3">
                                            <iframe class="has-ratio" width="640" height="360" 
                                            :src="news.url" frameborder="0" allowfullscreen></iframe>
                                          </figure>
                                        </b-carousel-item>
                                      </b-carousel>
                                    </div>
                                    <div class="column">
                                      Uploaded:
                                      <b-icon
                                          icon="timer"
                                          size="is-small">
                                      </b-icon>
                                        {{new Date(news.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
                                        <br>
                                        <b-button icon-right="arrow-right-bold" type="is-primary is-light" 
                                      outlined style="font-weight:bold;margin-left:5px" size="is-small"
                                      tag="router-link"
                                        :to="'/news/' + news.id_news"
                                        target="_blank">READ MORE
                                      </b-button> 
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </article>
                    </div>
                    <div class="column">
                      <nav class="is-pulled-right sidebar-kanan">
                        <div style="background-color:#00A7E7; margin-bottom: 0.5em; padding: 0.2em;border-radius:5px" @click="linktwitter()">
                            <b-icon
                            icon="twitter-box"
                            size="is-medium">
                        </b-icon> Follow Us on Twitter
                      </div>
                      <div style="background-color:#D93E06; margin-bottom: 0.5em; padding: 0.2em;border-radius:5px">
                            <b-icon
                            icon="email"
                            size="is-medium">
                        </b-icon> mail@bebras.or.id
                      </div>
                      <div style="background-color:#84A5F7;margin-bottom: 2.0em;padding: 0.2em;border-radius:5px" @click="linkemail()">
                            <b-icon
                            icon="link"
                            size="is-medium">
                        </b-icon> http://bebras.or.id
                      </div>
                          <b-field>
                            <b-input placeholder="Cari Berita..."
                                type="search"
                                v-model="cariNews"
                                icon="magnify"
                                icon-clickable
                                @icon-click="searchIconClick">
                            </b-input>
                        </b-field>
                          <!-- <br>
                          <p class="title is-5 is-spaced is-centered">KEGIATAN</p>
                          <p class="subtitle is-6">Bebras Challenge</p>
                          <p class="subtitle is-6">Workshop</p>
                          <p class="subtitle is-6">Kompetisi</p>
                          <p class="subtitle is-6">Latihan Soal</p>

                          <br> -->

                          <!-- <p class="title is-6 is-spaced is-centered">Link Terkait:</p> -->
                          <ul>
                            <p class="font-bold">Link Terkait:</p>
                          <li><a href="http://bebras.or.id/v3/bebras-biro/">Bebras Biro</a></li>
                          <li><a href="https://www.bebras.org/">Bebras Internasional</a></li>
                          <li><a href="https://olympia.id/login/index.php">Olympia</a></li>
                          <!-- <li><a href="https://latihanbebras.ipb.ac.id/">Latihan Soal</a></li> -->
                          <!-- <router-link to="/sortingnews">Archive News</router-link> -->
                          <br>
                          <!-- <router-link to="/sortingevent">Archive Event</router-link> -->
                        </ul>
                        <br>
                        <div style="margin-bottom: 0.8em; padding: 0.2em;border-radius:5px;background-color:white">
                          <div class="columns">
                          <div class="column">
                            <span class="image is-pulled-centered is-5by4">
                              <img src="../assets/gambar_sd.png" alt="car" style="object-position: center; object-fit: cover" />
                            </span>
                          </div>
                          <div class="column" style="font-size:14px;font-weight:bold">
                            Contoh soal Siaga untuk Siswa 
                            <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                          @click="linksd()">READ MORE
                          </b-button>
                          </div>
                        </div>
                        </div>
                        <div  style="margin-bottom: 0.8em; padding: 0.2em;border-radius:5px;background-color:white">
                          <div class="columns">
                            <div class="column">
                              <span class="image is-pulled-centered is-5by4">
                                <img src="../assets/gambar_smp.png" alt="car" style="object-position: center; object-fit: cover" />
                              </span>
                            </div>
                            <div class="column" style="font-size:14px;font-weight:bold">Contoh soal Penegak untuk Siswa SMP
                              <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                                @click="linksmp()">READ MORE
                              </b-button>
                            </div>
                          </div>
                        </div>
                        <div  style="margin-bottom: 0.8em; padding: 0.2em;border-radius:5px;background-color:white">
                          <div class="columns">
                            <div class="column">
                              <span class="image is-pulled-centered is-5by4">
                                <img src="../assets/gambar_sma.png" alt="car" style="object-position: center; object-fit: cover" />
                              </span>
                            </div>
                            <div class="column" style="font-size:14px;font-weight:bold">Contoh soal Penggalang untuk Siswa SMA
                                <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                                @click="linksma()">READ MORE
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </nav>  
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="columns" style="margin-top:2%">
                    <div class="column"></div>
                    <div class="column is-6">
                        <b-pagination
                        :total="totalNews"
                        :current.sync="currentNews"
                        range-before="2"
                        range-after="2"
                        order="is-centered"
                        rounded
                        :per-page="perPageNews"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page">
                    </b-pagination>
                    </div>
                    <div class="column"></div>
                  </div>
                </div>
              </div>
              <section>
              </section>
            </b-tab-item>
            <b-tab-item label="Podcast" icon="bullhorn">
              <div class="columns">
                <div class="column has-text-centered">  
                <h1 style="font-size:30px;font-weight:bold">GERAKAN PANDAI <span style="font-size:30px;font-weight:bold;color:blue">PODCAST</span></h1>
                </div>
              </div>
              <div class="rows">
                <div class="row">
                  <div class="columns">
                    <div class="column is-9">
                      <article>
                        <div id="datablog">
                          <div id="content">
                            <div>
                              <div class="columns is-multiline">
                                <div class="column is-half" v-for="podcast in paginatedItemsPodcast" :key="podcast.id_podcast" :data="podcast">
                                  <div class="card image animate__animated animate__backInUp">
                                    <div class="card-content">
                                      <h1 class="image animate__animated animate__backInUp has-text-centered" style="color:blue; font-size:20px"><b>{{podcast.title}}</b></h1>
                                    </div>
                                    <div class="card-image ">
                                      <b-carousel :autoplay="false" :interval="8000">
                                        <b-carousel-item v-if="podcast.picture !== null">
                                          <figure class="image is-3by3">
                                            <img style="object-position: center; object-fit: contain"  :src="getPicturePodcast(podcast.picture)" alt="Product photos">
                                          </figure>
                                        </b-carousel-item>

                                        <b-carousel-item v-if="podcast.picture1 !== null">
                                          <figure class="image is-3by3">
                                            <img style="object-position: center; object-fit: contain"  :src="getPicturePodcast(podcast.picture1)" alt="Product photos">
                                          </figure>
                                        </b-carousel-item>

                                        <b-carousel-item v-if="podcast.picture2 !== null">
                                          <figure class="image is-3by3">
                                            <img style="object-position: center; object-fit: contain"  :src="getPicturePodcast(podcast.picture2)" alt="Product photos">
                                          </figure>
                                        </b-carousel-item>

                                        <b-carousel-item v-if="podcast.url !== null">
                                          <figure class="image is-3by3">
                                            <iframe class="has-ratio" width="640" height="360" 
                                            :src="podcast.url" frameborder="0" allowfullscreen></iframe>
                                          </figure>
                                        </b-carousel-item>
                                      </b-carousel>
                                    </div>
                                    <div class="column">
                                      Uploaded:
                                      <b-icon
                                          icon="timer"
                                          size="is-small">
                                      </b-icon>
                                        {{new Date(podcast.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
                                        <br>
                                        <b-button icon-right="arrow-right-bold" type="is-primary is-light" 
                                      outlined style="font-weight:bold;margin-left:5px" size="is-small"
                                      tag="router-link"
                                        :to="'/podcast/' + podcast.id_podcast"
                                        target="_blank">READ MORE
                                      </b-button> 
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </article>
                    </div>
                    <div class="column">
                      <nav class="is-pulled-right sidebar-kanan">
                        <div style="background-color:#00A7E7; margin-bottom: 0.5em; padding: 0.2em;border-radius:5px" @click="linktwitter()">
                            <b-icon
                            icon="twitter-box"
                            size="is-medium">
                        </b-icon> Follow Us on Twitter
                      </div>
                      <div style="background-color:#D93E06; margin-bottom: 0.5em; padding: 0.2em;border-radius:5px">
                            <b-icon
                            icon="email"
                            size="is-medium">
                        </b-icon> mail@bebras.or.id
                      </div>
                      <div style="background-color:#84A5F7;margin-bottom: 2.0em;padding: 0.2em;border-radius:5px" @click="linkemail()">
                            <b-icon
                            icon="link"
                            size="is-medium">
                        </b-icon> http://bebras.or.id
                      </div>
                          <b-field>
                            <b-input placeholder="Cari Berita..."
                                type="search"
                                v-model="cariPodcast"
                                icon="magnify"
                                icon-clickable
                                @icon-click="searchIconClick">
                            </b-input>
                        </b-field>
                          <!-- <br>
                          <p class="title is-5 is-spaced is-centered">KEGIATAN</p>
                          <p class="subtitle is-6">Bebras Challenge</p>
                          <p class="subtitle is-6">Workshop</p>
                          <p class="subtitle is-6">Kompetisi</p>
                          <p class="subtitle is-6">Latihan Soal</p>

                          <br> -->

                          <!-- <p class="title is-6 is-spaced is-centered">Link Terkait:</p> -->
                          <ul>
                            <p class="font-bold">Link Terkait:</p>
                          <li><a href="http://bebras.or.id/v3/bebras-biro/">Bebras Biro</a></li>
                          <li><a href="https://www.bebras.org/">Bebras Internasional</a></li>
                          <li><a href="https://olympia.id/login/index.php">Olympia</a></li>
                          <!-- <li><a href="https://latihanbebras.ipb.ac.id/">Latihan Soal</a></li> -->
                          <!-- <router-link to="/sortingnews">Archive News</router-link> -->
                          <br>
                          <!-- <router-link to="/sortingevent">Archive Event</router-link> -->
                        </ul>
                        <br>
                        <div style="margin-bottom: 0.8em; padding: 0.2em;border-radius:5px;background-color:white">
                          <div class="columns">
                          <div class="column">
                            <span class="image is-pulled-centered is-5by4">
                              <img src="../assets/gambar_sd.png" alt="car" style="object-position: center; object-fit: cover" />
                            </span>
                          </div>
                          <div class="column" style="font-size:14px;font-weight:bold">
                            Contoh soal Siaga untuk Siswa 
                            <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                          @click="linksd()">READ MORE
                          </b-button>
                          </div>
                        </div>
                        </div>
                        <div  style="margin-bottom: 0.8em; padding: 0.2em;border-radius:5px;background-color:white">
                          <div class="columns">
                            <div class="column">
                              <span class="image is-pulled-centered is-5by4">
                                <img src="../assets/gambar_smp.png" alt="car" style="object-position: center; object-fit: cover" />
                              </span>
                            </div>
                            <div class="column" style="font-size:14px;font-weight:bold">Contoh soal Penegak untuk Siswa SMP
                              <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                                @click="linksmp()">READ MORE
                              </b-button>
                            </div>
                          </div>
                        </div>
                        <div  style="margin-bottom: 0.8em; padding: 0.2em;border-radius:5px;background-color:white">
                          <div class="columns">
                            <div class="column">
                              <span class="image is-pulled-centered is-5by4">
                                <img src="../assets/gambar_sma.png" alt="car" style="object-position: center; object-fit: cover" />
                              </span>
                            </div>
                            <div class="column" style="font-size:14px;font-weight:bold">Contoh soal Penggalang untuk Siswa SMA
                                <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                                @click="linksma()">READ MORE
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </nav>  
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="columns" style="margin-top:2%">
                    <div class="column"></div>
                    <div class="column is-6">
                        <b-pagination
                        :total="totalNews"
                        :current.sync="currentNews"
                        range-before="2"
                        range-after="2"
                        order="is-centered"
                        rounded
                        :per-page="perPageNews"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page">
                    </b-pagination>
                    </div>
                    <div class="column"></div>
                  </div>
                </div>
              </div>
              <section>
              </section>
            </b-tab-item>
            <b-tab-item label="Event" icon="google-photos" id="pelatihanevent">
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#0099ff" fill-opacity="1" d="M0,288L26.7,266.7C53.3,245,107,203,160,192C213.3,181,267,203,320,186.7C373.3,171,427,117,480,117.3C533.3,117,587,171,640,170.7C693.3,171,747,117,800,122.7C853.3,128,907,192,960,218.7C1013.3,245,1067,235,1120,208C1173.3,181,1227,139,1280,149.3C1333.3,160,1387,224,1413,256L1440,288L1440,0L1413.3,0C1386.7,0,1333,0,1280,0C1226.7,0,1173,0,1120,0C1066.7,0,1013,0,960,0C906.7,0,853,0,800,0C746.7,0,693,0,640,0C586.7,0,533,0,480,0C426.7,0,373,0,320,0C266.7,0,213,0,160,0C106.7,0,53,0,27,0L0,0Z"></path></svg> -->
            <div class="columns">
                <div class="column has-text-centered">  
                  <h1 style="font-size:30px;font-weight:bold">GERAKAN PANDAI <span style="font-size:30px;font-weight:bold;color:blue">EVENT</span></h1>
                </div>
              </div>
            <div class="rows">
              <div class="row">
                <div class="columns">
                  <div class="column is-9">
                    <article>
                      <div id="dataevent">
                  
                      <div id="content">
                        <div class="card" v-for="event in paginatedItemsEvent" :key="event.id_event" :data="event" style="margin-left:8%">
                          <div class="columns">
                            <div class="column">
                              <div class="card-image ">
                                  <figure class="image is-3by3"> 
                                    <img :src="getPictureEvent(event.pic_event)" alt="Placeholder image">
                                  </figure>
                                </div>
                            </div>
                            <div class="column">
                              <div style="margin:10px">
                                  <h1 class="image animate__animated animate__backInUp has-text-centered;" style="color:blue; font-size:16px"><b>{{event.nama_event}}</b></h1>
                                  <p style="font-weight:bold;font-size:14px"> Tanggal Pelaksanaan :</p>
                                    <div v-if="event.tgl_event !==null">
                                      <p style="font-size:20px;color:blue;" class="image animate__animated animate__backInUp">{{new Date(event.tgl_event).toLocaleDateString('id-ID',{ day:'numeric',month:'long',year:'numeric'}) }}</p>
                                      <!-- <p  style="font-size:20px;color:blue;">{{new Date(event.tgl_event).toLocaleDateString('id-ID',{month:'long',year:'numeric'}) }}</p> -->
                                    </div>

                                    <div v-else-if="event.tgl_event===null">
                                    -
                                    </div>
                                    <p style="font-weight:bold;font-size:14px">Pembicara :
                                    <span style="font-size:13px;font-weight:normal" class="animate__animated animate__backInUp"> {{ event.pembicara}}</span></p>
                                    
                                    <p style="font-weight:bold;font-size:14px">Tempat Acara:
                                    <span style="font-size:13px;font-weight:normal" class=" animate__animated animate__backInUp">{{ event.tempat_event}}</span></p>
                                    
                                    <p style="font-weight:bold;font-size:14px">Deskripsi :
                                    <span style="font-size:13px;font-weight:normal" class=" animate__animated animate__backInUp">{{ event.deskripsi}}</span></p>
                                </div>
                                  <div style="padding-left:10px;font-size:15px;">
                                  Uploaded:
                                  <b-icon
                                      icon="timer"
                                      size="is-small">
                                  </b-icon>
                                  {{new Date(event.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
                                </div>
                                  <div style="margin:10px">
                                  <b-button icon-right="arrow-right-bold" type="is-primary is-light" rounded
                                    outlined style="font-weight:bold;margin-left:5px" size="is-small"
                                    tag="router-link"
                                      :to="'/event/' + event.id_event"
                                      target="_blank">READ MORE
                                  </b-button> 
                                </div>
                            </div>
                          </div>
                        </div>
                        <div>
                        </div>
                      </div>

                    </div>
                    </article>
                  </div>
                  <div class="column">
                    <nav class="sidebar-kanan is-pulled-right">
                      <div style="background-color:#00A7E7; margin-bottom: 0.5em; padding: 0.2em;border-radius:5px" @click="linktwitter()">
                        <b-icon
                          icon="twitter-box"
                          size="is-medium">
                        </b-icon> Follow Us on Twitter
                      </div>
                      <div style="background-color:#D93E06; margin-bottom: 0.5em; padding: 0.2em;border-radius:5px">
                        <b-icon
                          icon="email"
                          size="is-medium">
                        </b-icon> mail@bebras.or.id
                      </div>
                      <div style="background-color:#84A5F7;margin-bottom: 2.0em;padding: 0.2em;border-radius:5px" @click="linkemail()">
                        <b-icon
                          icon="link"
                          size="is-medium">
                        </b-icon> http://bebras.or.id
                      </div>
                      <b-field>
                        <b-input placeholder="Search..."
                          type="search"
                          v-model="cariEvent"
                          icon="magnify"
                          icon-clickable
                          @icon-click="searchIconClick">
                        </b-input>
                      </b-field>
                      <!-- <br>
                      <p class="title is-5 is-spaced is-centered">KEGIATAN</p>
                      <p class="subtitle is-6">Bebras Challenge</p>
                      <p class="subtitle is-6">Workshop</p>
                      <p class="subtitle is-6">Kompetisi</p>
                      <p class="subtitle is-6">Latihan Soal</p>

                      <br> -->

                      <!-- <p class="title is-6 is-spaced is-centered">Link Terkait</p> -->
                      <ul>
                        <p class="font-bold"> Link Terkait:
                      <li><a href="http://bebras.or.id/v3/bebras-biro/">Bebras Biro</a></li>
                      <li><a href="https://www.bebras.org/">Bebras Internasional</a></li>
                      <li><a href="https://olympia.id/login/index.php">Olympia</a></li>
                      <!-- <li><a href="https://latihanbebras.ipb.ac.id/">Latihan Soal</a></li> -->
                      <!-- <router-link to="/sortingnews">Archive News</router-link> -->
                      <br>
                      <!-- <router-link to="/sortingevent">Archive Event</router-link> -->
                    </ul>
                    <br>
                    <div  style="margin-bottom: 0.8em; padding: 0.2em;border-radius:5px;background-color:white">
                      <div class="columns">
                      <div class="column" style=" margin-bottom: 0.1em;">
                        <span class="image is-pulled-centered is-5by4">
                          <img src="../assets/gambar_sd.png" alt="car" style="margin-top:2px; object-position: center; object-fit: cover" />
                        </span>
                      </div>
                      <div class="column" style="font-size:14px;font-weight:bold" >Contoh soal Siaga untuk Siswa SD
                        <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                      @click="linksd()">READ MORE
                    </b-button>
                      </div>
                    </div>
                    </div>
                    <div  style="margin-bottom: 0.8em; padding: 0.2em;border-radius:5px;background-color:white">
                      <div class="columns">
                      <div class="column">
                        <span class="image is-pulled-centered is-5by4">
                          <img src="../assets/gambar_smp.png" alt="car" style="object-position: center; object-fit: cover" />
                        </span>
                      </div>
                      <div class="column" style="font-size:14px;font-weight:bold">Contoh soal Penegak untuk Siswa SMP
                        <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="font-weight:bold" size="is-small"
                      @click="linksmp()">READ MORE
                    </b-button>
                      </div>
                    </div>
                    </div>
                    <div style="margin-bottom: 0.8em; padding: 0.2em;border-radius:5px;background-color:white">
                      <div class="columns">
                      <div class="column">
                        <span class="image is-pulled-centered is-5by4">
                          <img src="../assets/gambar_sma.png" alt="car" style="object-position: center; object-fit: cover" />
                        </span>
                      </div>
                      <div class="column" style="font-size:14px;font-weight:bold" >Contoh soal Penggalang untuk Siswa SMA
                        <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                      @click="linksma()">READ MORE
                    </b-button>
                      </div>
                    </div>
                    </div>
                  </nav>  

                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 2%">
                <div class="columns">
                  <div class="column"></div>
                  <div class="column is-6">
                    <b-pagination
                        :total="totalEvent"
                        :current.sync="currentEvent"
                        range-before="2"
                        range-after="2"
                        order="is-centered"
                        rounded
                        :per-page="perPageEvent"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page">
                    </b-pagination>
                  </div>
                  <div class="column"></div>
                </div>
              </div>
            </div>
            </b-tab-item>
            <b-tab-item label="Tabular" icon="table">
              <div id="content"  class="isikonten">
                <div class="box">
                  <b-navbar>
                  <template slot="start"></template>
                    <template slot="end">
                      <b-field position="is-centered">
                        <b-input placeholder="Search By Nama Event..."  type="search" v-model="search" rounded icon="magnify">
                        </b-input>
                    </b-field>
                    </template>
                  </b-navbar>
                  <section>
                    <b-table
                      :data="filteredList"
                      bordered
                      striped
                      narrowed
                      hoverable
                      :loading="isLoading"
                      :mobile-cards="true"
                      paginated
                      :per-page="perPage"
                      ref="table"
                      aria-next-label="Next page"
                      aria-previous-label="Previous page"
                      aria-page-label="Page"
                      aria-current-label="Current page"
                      :opened-detailed="defaultOpenedDetails"
                      detailed
                      detail-key="id_event"
                      @details-open="(row) => $buefy.toast.open(`Show Detail ${row.nama_event}`)"
                      :show-detail-icon="showDetailIcon">
                      <b-table-column field="index" label="No" width="40" numeric v-slot="props">
                            {{ props.row.index }}
                        </b-table-column>
                        <b-table-column
                        field="id_event"
                        label="ID"
                        sortable
                        :visible="false"
                        v-slot="props">
                        {{ props.row.id_event}}
                        </b-table-column>

                        <b-table-column field="nama_event" label="Nama Event" 
                        sortable
                        v-slot="props">
                            {{ props.row.nama_event}}
                        </b-table-column>

                        <b-table-column field="tgl_event" label="Tanggal Event"  
                        sortable
                        v-slot="props">
                          <div v-if="props.row.tgl_event === null">-</div>
                          <div v-else>{{new Date(props.row.tgl_event).toLocaleDateString('id-ID',{ year:'numeric', month:'long', day:'numeric'}) }}</div>
                        </b-table-column>

                        <b-table-column field="jenis_event" label="Jenis Event"  
                        sortable
                        v-slot="props">
                        <div v-html="props.row.jenis_event"></div>
                        </b-table-column>

                        <b-table-column field="linkdrive" label="Link Materi"  
                        sortable
                        v-slot="props">
                        <div v-html="props.row.linkdrive"></div>
                        </b-table-column>

                        <b-table-column field="jml_peserta" label="Jumlah Peserta"  
                        sortable
                        v-slot="props">
                        <div v-html="props.row.jml_peserta"></div>
                        </b-table-column>

                        <b-table-column field="total_rombel" label="Total Rombel"  
                        sortable
                        v-slot="props">
                        <div v-html="props.row.total_rombel"></div>
                        </b-table-column>


                        <b-table-column field="nama_biro" label="Biro"  
                        sortable
                        v-slot="props">
                        <div v-if="props.row.nama_biro === null">Super Admin</div>
                        <div v-else>{{ props.row.nama_biro }}</div>
                        </b-table-column>

                          <template slot="bottom-left">
                            <b-select v-model="perPage">
                            <option value="10">10 per page</option>
                            <option value="30">30 per page</option>
                            <option value="50">50 per page</option>
                          </b-select>
                        </template>

                        <template #detail="props">
                            <article class="media">
                                <div class="media-content">
                                    <div class="content">
                                        <p>
                                          <br>
                                          <small><b>Url Youtube : </b>
                                          <div v-html="props.row.url_youtube"></div>
                                          </small>
                                          <br>
                                          <small><b>Link Presensi : </b>
                                          <div v-html="props.row.url_youtube"></div>
                                          </small>
                                          <br>
                                        </p>
                                    </div>
                                </div>
                            </article>
                        </template>   
                        
                    </b-table>
                  </section>
                
                </div>
              </div>
            </b-tab-item>
          </b-tabs>   
      </section>
      <div class="rows ">
            <div class="row">
              <div class="columns">
                <div class="column"></div>
                <div class="column">
                  <div class="box" style="margin-top:10%" >
                    <span class="image is-pulled-centered is-4by3">
                      <img src="../assets/bukuCI.png" alt="car" style="margin-top:5px; object-position: center; object-fit: contain" />
                    </span>
                    <p style="has-text-centered;font-weight:bold">Mengenal tentang Bebras Indonesia</p>   
                    <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                    @click="linkbebras()">READ MORE
                    </b-button>
                  </div>
                </div>
                  <div class="column">
                  <div class="box" style="margin-top:10%">
                    <span class="image is-pulled-centered is-4by3">
                      <img src="../assets/google1.png" alt="car" style="margin-top:5px; object-position: center; object-fit: contain" />
                    </span>
                    <p style="has-text-centered;font-weight:bold">Mengenal tentang Google.org</p>   
                      <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                      @click="linkgoogle()">READ MORE
                    </b-button>               
                  </div>
                </div>
                <div class="column">
                  <div class="box" style="margin-top:10%">
                    <span class="image is-pulled-centered is-4by3">
                      <img src="../assets/bahassoal.png" alt="car" style="margin-top:5px; object-position: center; object-fit: contain" />
                    </span>
                    <p style="has-text-centered;font-weight:bold">Pembahasan Soal Bebras Challenge</p>
                      <b-button icon-right="arrow-right-bold" type="is-primary is-light" outlined style="margin-top:5px;font-weight:bold" size="is-small"
                      @click="bahassoal()">READ MORE
                    </b-button> 
                  </div>
                </div>
                <div class="column"></div>
              </div>
            </div>
      </div>
      <section>
        <div class="hero-body" style="background-color:#F2F1F7">
          <p style="font-weight:bold">Kumpulan Galeri Photo</p>
          <b-carousel-list v-model="test" :data="items" :items-to-show="3">
              <template #item="list">
                  <div class="card">
                      <div class="card-image">
                          <figure class="image is-5by3">
                              <a @click="info(list.index)"><img :src="list.image" style="object-fit:cover;object-position:center"></a>
                          </figure>
                          <b-tag type="is-danger" rounded style="position: absolute; top: 0;"><b>Galeri</b></b-tag>
                      </div>
                  </div>
              </template>
          </b-carousel-list>
        </div>
      </section>
      <footer>
      <span class="image is-3by1">
            <img style="object-position: center; object-fit: contain" src="../assets/logofiks.jpg">
      </span>
      </footer>

      <footer style="background-color: #2196F3">
        <div class="container">
          <div class="rows">
              <div class="row">
                <p class="has-text-centered" style="font-size:20px"> Copyright Gerakan Pandai © 2021. All rights reserved. </p>
              </div>
            </div>
        </div>
      </footer>
    </div>
    
  </div>
</template>
<style scoped>

.colorheader{
  /* background-color:#87CEE8; */
  background-color: #2196F3;

}

.colorbackground{
   background-image: url("../assets/bg_gerakan_pandai.png"); 
   background-repeat: repeat;
}
.colorfooter{
  /* background: linear-gradient(to bottom right, #99ccff 0%, #cc99ff 100%); 
   */
   /* background-image: url("../assets/bg_gerakan_pandai.png");
   background-repeat: repeat; */
   
   background-color: #7FCCFF;
}



</style>
 
<script>
const ModalForm = {
    props: ['email','password'],
    template: `
    <form action="">
      <div class="modal-card" style="width: 350px">
        <header class="modal-card-head">
          <p class="modal-card-title has-text-centered">Login</p>
        </header>
        <section class="modal-card-body">
          <b-field 
            label="Email"
            :type="email.type"
            :message="email.message">
            <b-input 
              v-model="email.value" 
              placeholder="Your Email" required
              @input="netralizeEmail()">
            </b-input>
          </b-field>
          <b-field 
            label="Password"
            :type="password.type"
            :message="password.message">
            <b-input 
              type="password" 
              v-model="password.value" 
              @input="netralizePassword()" 
              placeholder="Your password" required
              password-reveal>
            </b-input>
          </b-field>
          
        </section>
        <footer class="modal-card-foot">
          <b-button type="button" expanded @click="$parent.close(),reset()">Close</b-button>
          <b-button type="is-primary" expanded @click="$emit('login')">Login</b-button>
        </footer>
      </div>
    </form>
    `,
    methods:{
      netralizeEmail(){
        this.$emit("netralizeEmail")
      },
      netralizePassword(){
        this.$emit("netralizePassword")
      },
      reset(){
        this.email.type='',
        this.email.message='',
        this.email.value ='',
        this.password.value ='',
        this.password.message='',
        this.password.type=''
      }
    }
  }
 

export default {
  components: {
      ModalForm
      },
      data() {
        return {
          state: true,
          defaultOpenedDetails: [1],
          showDetailIcon: true,
          perPage:'10',
          grafik:Object,
          all:Object,

          currentPodcast: 1,
          perPagePodcast: 6,

          currentEvent: 1,
          perPageEvent: 6,

          currentNews: 1,
          perPageNews: 6,

          carousel:true,
          isLoading: false,
          items: [
            {
                title: 'Slide 1',
                image: '/gallery/pandai1.jpeg'
            },
            {
                title: 'Slide 2',
                image: '/gallery/pandai2.jpeg'
            },
            {
                title: 'Slide 3',
                image: '/gallery/pandai3.jpeg'
            },
            {
                title: 'Slide 4',
                image: 'https://socs.binus.ac.id/files/2018/09/WhatsApp-Image-2018-08-31-at-10.35.19-640x360.jpeg'
            },
            {
                title: 'Slide 6',
                image: 'https://miro.medium.com/max/1240/0*allclr5UmQ8F1PRg.jpg'
            },
            {
                title: 'Slide 7',
                image: 'https://sekolahtumbuh.sch.id/wp-content/uploads/2020/01/WhatsApp-Image-2020-01-28-at-14.03.32-750x458.jpeg'
            },
              {
                title: 'Slide 9',
                image: 'https://www.sttgarut.ac.id/wp-content/uploads/2020/06/img693.jpg'
            },
              {
                title: 'Slide 11',
                image: 'https://cdn.krjogja.com/wp-content/uploads/2020/12/IMG-20201204-WA0000.jpg'
            },
              {
                title: 'Slide 14',
                image: 'https://socs.binus.ac.id/files/2018/09/WhatsApp-Image-2018-08-31-at-10.00.02.jpeg'
            },
              {
                title: 'Slide 15',
                image: 'https://i.ytimg.com/vi/Yl7F0J8LbGQ/maxresdefault.jpg'
            },
              {
                title: 'Slide 16',
                image: 'https://ft.ulm.ac.id/id/wp-content/uploads/2020/09/ss7-MUTIA-MAULIDA.png'
            },
              {
                title: 'Slide 18',
                image: 'https://pbs.twimg.com/media/EeFZaouUMAAztA4.png'
            },

        ],

          snackbarMessage:'',
          newses:[],
          events:[],
          podcast: [],
          search:'',
          cariNews:'',
          cariEvent:'',
          cariPodcast: '',
          acara:Object,
          berita:Object,
          isDetail:false,
          isComponentModalActive: false,
          formProps: {
            email: { value: '', type: '', message: '' },
            password: { value: '', type: '', message: '' },
          },
          config: {}
        }
      },
  methods: {
    homepage(){
      this.$router.push('/')
      this.state = true;
      localStorage.setItem('state', JSON.stringify(this.state));
    },
    tentang(){
      this.$router.push('/tentang')
      this.state = false;
      localStorage.setItem('state', JSON.stringify(this.state));
    },
    grafikPerBiro(){
      this.$router.push('/grafikperbiro')
      this.state = false;
      localStorage.setItem('state', JSON.stringify(this.state));
    },
    grafikAll(){
      this.$router.push('/grafikall')
      this.state = false;
      localStorage.setItem('state', JSON.stringify(this.state));
    },
    sortEvent(){
      this.$router.push('/sortingevent')
      this.state = false;
      localStorage.setItem('state', JSON.stringify(this.state));
    },
    sortBlog(){
      this.$router.push('/sortingnews')
      this.state = false;
      localStorage.setItem('state', JSON.stringify(this.state));
    },
    getDataGambarKumulatif()
    {
      var uri = this.$apiUrl + 'gambar/kumulatif'

      this.$http.get(uri).then(response =>
      {
        this.grafik = response.data.value
        console.log(this.grafik)
      })
    
    },
    getDataBiro()
    {
        var uri = this.$apiUrl + 'report/all' 
        this.$http.get(uri, this.config).then(response=>
        {
            this.all = response.data.value
        })
    },
  
    bahassoal()
    {
      window.open('http://bebras.or.id/v3/pembahasan-soal/')
    },
    linkgoogle(){
      window.open('https://www.google.org/')
    },
    linkbebras()
    {
      window.open('https://www.google.com/url?sa=t&rct=j&q=&esrc=s&source=web&cd=&cad=rja&uact=8&ved=2ahUKEwijzYaBsdXuAhWBX30KHWZTAY4QFjAAegQIARAD&url=http%3A%2F%2Fbebras.or.id%2F&usg=AOvVaw3R604JIm9QaThiwg8UK1Iq')
    },
    linksoal()
    {
      window.open('http://bebras.or.id/v3/pembahasan-soal/')
    },
    linktwitter()
    {
      window.open('https://twitter.com/bebrasindonesia')
    },
    linksd()
    {
      window.open('http://bebras.or.id/v3/contoh-soal-siaga-untuk-siswa-sd/')
    },
    linksmp()
    {
      window.open('http://bebras.or.id/v3/contoh-soal-penggalang-untuk-siswa-smp/')
    },
    linksma()
    {
      window.open('http://bebras.or.id/v3/contoh-soal-penegak-untuk-siswa-sma/')
    },
     
    getBiro(id){
      var uri = this.$apiUrl + 'biro/' + id
      this.$http
        .get(uri, this.config)
        .then(response => {
          var biro = response.data.value
          this.$session.set('biro', biro)
          this.$router.push({ name: "Biro" })
        })
        .catch(error => {
        })
    },

    checkData(){
      let count = 0
      
      if(this.formProps.email.value == "")
      {
        this.formProps.email.type = 'is-danger'
        this.formProps.email.message = 'Email harus diisi'
        count++
      }
      if(this.formProps.password.value == "")
      {
        this.formProps.password.type = 'is-danger'
        this.formProps.password.message = 'Password harus diisi'
        count++
      }

      if(count > 0)
        return false
    },

    login()
    {
      this.isLoading = true
      var self = this

      if(this.checkData() === false){
        this.snackbar("Gagal login, terdapat input yang salah",'is-danger')
        this.isLoading = false
      }else{
        var login = new FormData() 
        login.append('email',this.formProps.email.value);
        login.append('password',this.formProps.password.value);
        
        var url = this.$apiUrl + 'user/login'
        this.$http.post(url,login).then(response =>{
          this.isLoading = false
          if(response.data.message === "Authenticated"){
            var user = response.data.user
            self.$session.start()
            self.$session.set('user', user)
            self.$session.set('isLogin', true);
            self.$session.set('token', response.data.access_token)
            
            if(user.role === "Super Admin")
            {
              this.$router.push({ name: "BerandaBiro" })
              this.snackbar("Berhasil Login",'is-success')
            }else if(user.role === "Koordinator Biro"){
              this.config = {
                headers: {
                  'Authorization': 'Bearer ' + response.data.access_token
                }
              }
              this.getBiro(user.id_biro)
            }
          }
        })
        .catch(error=>
        {
          this.errors = error;
          console.log(this.errors)
          this.isLoading = false;
          if(error.response.status === 400){
            this.formProps.email.type = 'is-danger'
            this.formProps.email.message = 'Email harus valid'
            this.snackbar("Gagal login, terdapat input yang salah",'is-danger')
          }else if(error.response.status === 401)
          {
            this.formProps.password.type = 'is-danger'
            this.formProps.password.message = 'Password salah'
            this.snackbar("Gagal login, password salah",'is-danger')
            // if(this.formProps.password.value == "")
            // {
            //   this.formProps.password.type = 'is-danger'
            //   this.formProps.password.message = 'Password harus diisi'
            // }
            //  if(this.formProps.email.value == "")
            // {
            //   this.formProps.email.type = 'is-danger'
            //   this.formProps.email.message = 'Email harus diisi'
            // }
          }else if(error.response.status === 404){
            this.formProps.email.type = 'is-danger'
            this.formProps.email.message = 'Email tidak ditemukan'
            this.formProps.password.type = 'is-danger'
            this.formProps.password.message = 'Password salah'
            this.snackbar("Gagal login, email dan password salah",'is-danger')
          }else{
            this.snackbar("Gagal login, ada masalah pada jaringan",'is-danger')
          }
        });
      }
    },
    detailEvent(event)
    {
      this.isDetail= true
      this.acara = event
    },
    netralize(formProps) { 
    formProps.type = ''
    formProps.message = ''
    },
    getData()
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'sorting/news'

      this.$http.get(uri).then(response =>
      {
        this.newses = response.data.value
        
        for(var i=0; i<this.newses.length; i++)
        {
          this.newses[i].index = i+1
        }
        
        this.tableMessage ='Tidak ada data yang sesuai'
        this.isLoading=false

        
      })
      .catch(error =>{
        this.errors = console.error
        this.tableMessage='Tidak ada Data'
        this.isLoading = false
      })
    },
    getPicture(picture){
      var uri = this.$apiUrl + 'news/picture/' + picture
        
      return uri;
    },

    getPicturePodcast(pic_podcast){
      var uri = this.$apiUrl + 'podcast/picture/' + pic_podcast
        
      return uri;
    },
    getDataPodcast()
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'sorting/podcast'

      this.$http.get(uri).then(response =>
      {
        this.podcast = response.data.value
        
        for(var i=0; i<this.podcast.length; i++)
        {
          this.podcast[i].index = i+1
        }
        
        this.tableMessage ='Tidak ada data yang sesuai'
        this.isLoading=false 
      })
      .catch(error =>{
        this.errors = console.error
        this.tableMessage='Tidak ada Data'
        this.isLoading = false
      })
    },
        
    getDataEvent()
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'sorting/event'

      this.$http.get(uri).then(response =>
      {
        this.events = response.data.value
        this.isLoading=false
        console.log(this.events)
        for(var i=0; i<this.events.length; i++)
        {
          this.events[i].index = i+1
          var str = this.events[i].deskripsi
          // this.events[i].nama_biro ==='Super Admin'
          console.log(str)
          if(str.length > 150){
            var string = str.substring(0, 149) + "..."
            this.events[i].deskripsi = string
            console.log(this.events[i])
          }
          if(this.events[i].id_biro === null){
            this.events[i].nama_biro = 'Super Admin'
          }
              
          }
        
      })
    },
    getPictureEvent(pic_event){
      var uri = this.$apiUrl + 'event/picture/' + pic_event
        
      return uri;
    },
    getDataEventAll()//tabel
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'sorting/event' 

      this.$http.get(uri,this.config).then(response =>
      {
        this.events = response.data.value
        console.log(this.events)
        for(var i=0; i<this.events.length; i++)
        {
          this.events[i].index = i+1
        }
        //this.tableLoadingIcon = "emoticon-sad"
        this.tableMessage ='Tidak ada data yang sesuai'
        this.isLoading=false
      })
      .catch(error =>{
        this.errors = console.log(error)
        //this.tableLoadingIcon = "emoticon-sad"
        this.tableMessage='Tidak ada Data'
        this.isLoading = false
      })
    },
    snackbar(snackbarMessage,type)
    {
        this.$buefy.toast.open({
            duration : 5000,
            message: snackbarMessage,
            type: type,
            position: 'is-top',
            actionText :'OK',
            queue: false,
        })
    },
    resetForm(){
      this.formProps.email.value = '',
      this.formProps.password.value = ''
    },
      
    home()
    {
      this.$router.push({
        name:"Homepage"
      })
    },
  },
  computed: {
    filteredNews() {
      if(this.cariNews === ''){
        return this.newses
      }else{
        return this.newses.filter((news) => {
          return news.title.toLowerCase().includes(this.cariNews.toLowerCase()) 
        })
      }
    },
    filteredPodcast() {
      if(this.cariPodcast === ''){
        return this.podcast
      }else{
        return this.podcast.filter((podcast) => {
          return podcast.title.toLowerCase().includes(this.cariPodcast.toLowerCase()) 
        })
      }
    },
    filteredList()
    {
      
       return this.events.filter(event=>{
         if(event.nama_biro != null){
          return event.nama_event.toLowerCase().includes(this.search.toLowerCase()) ||
          event.jenis_event.toLowerCase().includes(this.search.toLowerCase()) ||
          event.nama_biro.toLowerCase().includes(this.search.toLowerCase())
         }else{
          return event.nama_event.toLowerCase().includes(this.search.toLowerCase()) ||
          event.jenis_event.toLowerCase().includes(this.search.toLowerCase()) 
         }
       
        })
      
    },
    filteredEvent() {
      if(this.cariEvent === ''){
        return this.events
      }else{
        return this.events.filter((event) => {
          return event.nama_event.toLowerCase().includes(this.cariEvent.toLowerCase()) ||
          event.nama_event.toLowerCase().includes(this.cariEvent.toUpperCase()) ||
          event.deskripsi.toLowerCase().includes(this.cariEvent.toLowerCase()) ||
          event.deskripsi.toLowerCase().includes(this.cariEvent.toUpperCase()) ||
          event.tempat_event.toLowerCase().includes(this.cariEvent.toLowerCase())
        })
      }
    },
    totalEvent(){
      return this.filteredEvent.length
    },
    paginatedItemsEvent(){
      let page_number = this.currentEvent-1
      return this.filteredEvent.slice(page_number * this.perPageEvent, (page_number + 1) * this.perPageEvent);
    },
     totalNews(){
      return this.filteredNews.length
    },
    paginatedItemsNews(){
      let page_number = this.currentNews-1
      return this.filteredNews.slice(page_number * this.perPageNews, (page_number + 1) * this.perPageNews);
    },
    totalPodcast(){
      return this.filteredPodcast.length
    },
    paginatedItemsPodcast(){
      let page_number = this.currentPodcast-1
      return this.filteredPodcast.slice(page_number * this.perPagePodcast, (page_number + 1) * this.perPagePodcast);
    }
  },
  mounted()
  {
    this.getDataEvent()//sorting event
    this.getDataGambarKumulatif()
    this.getDataBiro()
    this.getData()//sorting news
    this.getDataPodcast()
  
    if(localStorage.getItem('state') !== null){
      this.state = JSON.parse(localStorage.getItem('state'))
    }
    console.log(this.state)

  },
   
}
</script>

<style scoped>
.fit-image{
  object-position: center;
  object-fit: contain;
}
.card {
  margin-right: 10px;
  margin-bottom: 10px;
  max-width: 100%;
  height: 100%;
  box-shadow: none;
  border: solid 1px #dadbe6;
  border-radius: 10px;
  overflow: hidden;
}

div.background {
  background: url('../assets/bebrasNBO1.jpg') no-repeat;
   border: 1px solid black;
   background-size: cover;
}

div.transbox {
  margin: 50px;
  border: 1px solid black;
  opacity: 0.8;
}

div.transbox p {
  margin: 4.5%;
  font-weight: bold;
  color: #000000;
}

.gambar-news {
  width: 100%;
}
.border{
  border-right-style: solid;
   border-width: 3px;
}

.logo-bebras {
  width: 100px;
  height: 100px;
  position: relative;
  animation: mymove-right 5s infinite;
}

@keyframes mymove-right {
  from {left: 200px;}
  to {left: 0px;}
}

.logo-pandai {
  width: 100px;
  height: 100px;
  position: relative;
  animation: mymove-left 5s infinite;
}

@keyframes mymove-left {
  from {left: -300px;}
  to {left: 0px;}
}

/* .logo-fot-left {
  width: 100px;
  height: 100px;
  position: relative;
  animation: mymove-left 10s infinite;
}

@keyframes mymove-left {
  from {left: -300px;}
  to {left: 0px;}
}

.logo-fot-right {
  width: 100px;
  height: 100px;
  position: relative;
  animation: mymove-right 10s infinite;
}

@keyframes mymove-right {
  from {left: 400px;}
  to {left: 0px;}
} */




* {
  box-sizing: border-box;
}

body {
  font-family: Arial, Helvetica, sans-serif;
}

.sidebar-kanan {
  width: 90%;
  background: #EDE7F6;
  padding: 20px;
  border-radius: 15px !important;
}

nav ul {
  list-style-type: none;
  padding: 0;
}

</style>

